// extracted by mini-css-extract-plugin
export default {"fullHeight":"style_fullHeight__PTxEt"};